import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login/Login.vue'
import PatientEducation from '@/views/patient/education/PatientEducation.vue'
import { Roles } from "@/common/roles.service";


Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    redirect: '/login',
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/launch',
    name: 'launch',
    component: () => import('@/views/Fhir/Launch.vue'),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/fhir',
    name: 'fhir',
    component: () => import('@/views/Fhir/FhirApp.vue'),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/error',
    name: 'ErrorPage',
    props: true,
    component: () => import('@/views/Error/Error500.vue'),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('@/views/Error/Unauthorized.vue'),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/org-notfound',
    name: 'org-notfound',
    component: () => import('@/views/Fhir/organizationnotfound.vue'),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/contactAdmin',
    name: 'ErrorContactAdmin',
    props: true,
    component: () => import('@/views/Error/ErrorContactAdmin.vue'),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/patient-details',
    name: 'patient-details',
    component: () => import('@/views/PatientInformation/PatientView.vue'),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashBoard',
    component: () => import('@/views/Dashboards/MirusAdminDashBoard.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.MIRUS_ADMIN, Roles.ADMIN]
    },
  },
  {
    path: '/dashboard',
    name: 'ClinicianDasboard',
    component: () => import('@/views/Dashboards/ClinicianDashboard.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.PHYSICIAN, Roles.STAFF, Roles.MIRUS_NURSE]
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Dashboards/index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/search',
    name: 'PatientSearchPage',
    component: () => import('@/views/PatientInformation/PatientSearchPage.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.PHYSICIAN, Roles.ADMIN, Roles.MIRUS_ADMIN, Roles.STAFF, Roles.MIRUS_NURSE]
    },
  },
  {
    path: '/register/patient',
    name: 'ClinicianPatientRegistration',
    component: () => import('@/views/PatientRegistration/ClinicianPatientRegistration.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.PHYSICIAN, Roles.ADMIN, Roles.STAFF, Roles.MIRUS_ADMIN, Roles.MIRUS_NURSE]
    },
  },
  {
    path: '/patient',
    name: 'PatientView',
    component: () => import('@/views/PatientInformation/PatientView.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.PHYSICIAN, Roles.STAFF, Roles.ADMIN, Roles.MIRUS_ADMIN, Roles.MIRUS_NURSE]
    },
  },
  {
    path: '/fitbit',
    name: 'FitbitView',
    component: () => import('@/views/patient/fitbit/FitbitView.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/fitbit/response',
    name: 'FitbitResponse',
    component: () => import('@/views/patient/fitbit/FitbitView.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/fitbit/error',
    name: 'FitbitError',
    component: () => import('@/views/patient/fitbit/FitbitError.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/fitbit/success',
    name: 'FitbitSetupSuccess',
    component: () => import('@/views/patient/fitbit/FitbitSetupSuccess.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/newuser',
    name: 'NewUser',
    component: () => import('@/views/User/NewUser.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/createuser',
    name: 'CreateUser',
    component: () => import('../views/User/CreateEditUser.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.ADMIN, Roles.MIRUS_ADMIN]
    },
  },
  {
    path: '/edituser/:userId',
    name: 'EditUser',
    component: () => import('../views/User/CreateEditUser.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.MIRUS_ADMIN, Roles.ADMIN]
    },
  },
  // functionality removed for now
  // {
  //   path: '/resetpassword',
  //   name: 'ResetPassword',
  //   component: () => import('@/views/User/PasswordReset.vue'),
  //   meta: {
  //     requiresAuth: false,
  //   },
  // },
  {
    path: '/updatepatient',
    name: 'UpdatePatientDemographics',
    props: true,
    component: () => import('@/views/PatientRegistration/ClinicianPatientRegistration.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.PHYSICIAN, Roles.STAFF, Roles.ADMIN, Roles.MIRUS_ADMIN, Roles.MIRUS_NURSE]
    },
  },
  {
    path: '/patient/education/',
    name: 'PatientEducation',
    component: PatientEducation,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/patient/verification',
    name: 'PatientVerification',
    component: () => import('@/views/PatientRegistration/PatientVerification.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/survey',
    name: 'SurveyDetail',
    component: () => import('@/views/patient/survey/survey.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/billing',
    name: 'Billing',
    component: () => import('@/views/Billing/Billing.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.PHYSICIAN, Roles.ADMIN, Roles.MIRUS_ADMIN, Roles.STAFF, Roles.BILLING, Roles.MIRUS_NURSE]
    },
  },
  {
    path: '/kiosk-mode',
    name: 'kioskmode',
    component: () => import('@/views/KioskMode/KioskModeRoute.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/selectOrganisation',
    name: 'selectOrganisation',
    component: () => import('@/views/SelectOrganisation/SelectOrganisation.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.PHYSICIAN, Roles.ADMIN, Roles.MIRUS_ADMIN, Roles.STAFF, Roles.BILLING, Roles.MIRUS_NURSE]
    },
  },
  {
    path: '/manageOrganization',
    name: 'manageOrganization',
    component: () => import('@/views/ManageOrganisation/ManageOrganisation.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.MIRUS_ADMIN]
    },
  },
  {
    path: '/manageDevices',
    name: 'manageDevices',
    component: () => import('@/views/ManageDevices/ManageDevices.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.MIRUS_ADMIN]
    },
  },
  {
    path: '/carePlan',
    name: 'carePlan',
    component: () => import('@/views/CarePlan/CarePlan.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.MIRUS_ADMIN, Roles.ADMIN]
    },
  },
  {
    path: '/appointment/video',
    name: 'AppointmentVideo',
    component: () => import('@/views/Video/Video.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.PHYSICIAN, Roles.ADMIN, Roles.MIRUS_ADMIN, Roles.STAFF, Roles.MIRUS_NURSE]
    },
  },
  {
    path: '/telemedicine',
    name: 'Telemedicine',
    component: () => import('@/views/Appointment/Appointment.vue'),
    meta: {
      requiresAuth: true,
      allowedUsers: [Roles.PHYSICIAN, Roles.ADMIN, Roles.MIRUS_ADMIN, Roles.STAFF, Roles.MIRUS_NURSE]
    }
  },
  {
    path: '/*',
    name: 'Error404',
    component: () => import('@/views/Error/Error404.vue'),
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



export default router
